import { jsxs as c, jsx as t } from "react/jsx-runtime";
import s from "./Toast.module.css.js";
const o = ({ title: a, description: e }) => /* @__PURE__ */ c("div", { className: s.content, children: [
  /* @__PURE__ */ t("span", { className: s.title, children: a }),
  e && /* @__PURE__ */ t("span", { className: s.description, children: e })
] });
export {
  o as Toast
};
//# sourceMappingURL=Toast.js.map
